import React from 'react'
import BannerWave from '../components/BannerWave'

// Components
import Button from '../components/Button'

const GradientHeader = (props) => (
    <header className="gradient-header">
        <div className="gradient-content">
            <h1>{props.header}</h1>
            <h2 dangerouslySetInnerHTML={{ __html: props.subheader }}></h2>
            {props.bookButton === "true" ? 
                <Button buttonClass="book-button third" buttonText="let's chat"/>
                : false
            }
        </div>
        <BannerWave dir="top"/>
        {props.backButton === "true" ? 
            <div className="back-button-container">
                <a className="button alt back-button" href="/past-work">More Work</a> 
            </div>
            : false
        }
    </header>
);

export default GradientHeader